import { ai } from '@sekoia/shared/utils/telemetryService';

export const updateClarityIdentity = (globalId: string): void => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
  const clarity = (<any>window).clarity;
  if (clarity) {
    clarity('identify', globalId, ai.getSessionId());
  }
};
